<template>
  <svg width="24" height="24" viewBox="0 0 24 24">
    <path
      d="M18.43 18.433c.421-.43.421-1.132.008-1.545l-4.883-4.884 4.883-4.892a1.102 1.102 0 0 0-.008-1.545 1.11 1.11 0 0 0-1.545-.008L12 10.442 7.109 5.56c-.396-.405-1.124-.422-1.545.008-.421.422-.413 1.149-.008 1.545l4.883 4.892-4.883 4.884c-.405.405-.413 1.123.008 1.545.43.421 1.149.413 1.545.016l4.892-4.891 4.884 4.883a1.11 1.11 0 0 0 1.545-.008z"
      fill="#737380"
      fill-rule="evenodd"
    />
  </svg>
</template>
